var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_896_308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 50.75C38.8071 50.75 50 39.5571 50 25.75C50 11.9429 38.8071 0.75 25 0.75C11.1929 0.75 0 11.9429 0 25.75C0 39.5571 11.1929 50.75 25 50.75Z",
    fill: "#00587E"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_896_308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.2392 13.75L25.0811 14.2875V29.8837L25.2392 30.0415L32.4788 25.7622L25.2392 13.75Z",
    fill: "#99BCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2396 13.75L18 25.7622L25.2396 30.0416V22.4716V13.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2385 31.4123L25.1494 31.5209V37.0766L25.2385 37.3369L32.4824 27.1351L25.2385 31.4123Z",
    fill: "#99BCCB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2396 37.3368V31.4121L18 27.135L25.2396 37.3368Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2402 30.0415L32.4797 25.7622L25.2402 22.4717V30.0415Z",
    fill: "#337998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 25.7622L25.2395 30.0415V22.4717L18 25.7622Z",
    fill: "#99BCCB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_896_308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.75)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_896_308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(13 13.75)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthIcon);
export default __webpack_public_path__ + "static/media/eth-icon.daa67e7551a31e5c86cf48e06a44691c.svg";
export { ForwardRef as ReactComponent };